import Plyr from 'plyr';
import 'plyr/dist/plyr.css';


export function initVideoPlayer (video) {
  const holder = video.querySelector('.plyr__video-embed');

  const player = new Plyr(holder, {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'fullscreen'
    ],
    autoplay: false,
    muted: true,
    loop: { active: false },
  });
}

document.querySelectorAll('[data-video]').forEach(video => initVideoPlayer(video));

